module.exports = __webpack_public_path__ + "media/images/hastakshar-253b4e78.svg";